import {
  Link,
  Progress,
  ResponseErrorPanel,
  MarkdownContent,
} from '@backstage/core-components';
import { Entity } from '@backstage/catalog-model';
import Stack from '@mui/material/Stack';
import Card from '@mui/material/Card';
import Button from '@mui/material/Button';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import CardHeader from '@mui/material/CardHeader';
import { useUnprocessedEntities } from '../../../hooks';
import { useStyles } from './unprocessed-styles';

export const UnprocessedEntitiesCards = () => {
  const classes = useStyles();
  const { loading, error, unprocessedItems } = useUnprocessedEntities();

  const items = unprocessedItems ?? [];

  return (
    <Stack direction="column" spacing={2}>
      {loading && <Progress />}
      {error && <ResponseErrorPanel error={error} />}
      {!loading && !error && items.length > 0 ? (
        items.map(item => {
          if (!item) return null;
          const entity: Entity | undefined = item.unprocessed_entity;

          const typeErrorMessage = (item.errors ?? [])
            .map((e: any) => {
              const match = e.message.match(
                /caused by (?:Error|TypeError):\s*(.*)/,
              );
              return match ? match[1] : e.message;
            })
            .filter(Boolean)
            .join(', ');

          return (
            <Card
              key={item.entity_ref}
              className={`${classes.card} ${classes.errorCard}`}
            >
              <CardHeader
                title={entity?.metadata.name}
                subheader={entity?.kind}
                classes={{
                  title: classes.cardTitle,
                  subheader: classes.cardSubheader,
                }}
              />
              <CardContent className={classes.cardContent}>
                <MarkdownContent content={typeErrorMessage} />
              </CardContent>
              <CardActions>
                <Button
                  size="small"
                  color="primary"
                  variant="outlined"
                  component={Link}
                  to={item.location_key ?? '#'}
                  underline="none"
                  target="_blank"
                >
                  Go to Source
                </Button>
              </CardActions>
            </Card>
          );
        })
      ) : (
        <Card className={`${classes.card} ${classes.successCard}`}>
          <CardHeader
            title="Nothing to worry!"
            subheader="All entities you own have been successfully processed."
            classes={{
              title: classes.cardTitle,
              subheader: classes.cardSubheader,
            }}
          />
        </Card>
      )}
    </Stack>
  );
};
